// extracted by mini-css-extract-plugin
module.exports = {"hidden":"index_hidden_ycvpn","text-default":"index_text-default_3sfhB"};